export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
            <div className="md:col-span-4 flex flex-col gap-4">
              <a href="/" className="flex items-center gap-2" aria-label="SaloonS">
                <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-sparkling-line text-background-50 text-xl"></i>
                </span>
                <span className="text-xl font-bold text-foreground-900 font-heading">
                  Saloon<span className="text-primary-500">S</span>
                </span>
              </a>
              <p className="text-sm text-foreground-500 leading-relaxed max-w-xs">
                İstanbul'un en kapsamlı güzellik kampanyası keşif platformu. Saç, kalıcı makyaj, lazer epilasyon, cilt bakımı, gençleşme, solaryum ve bölgesel incelme alanlarında 15.000+ mutlu müşteri.
              </p>
              <div className="flex items-center gap-3 mt-2">
                <a
                  href="https://wa.me/905433724578"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 hover:bg-primary-200 transition-colors cursor-pointer"
                  aria-label="WhatsApp"
                >
                  <i className="ri-whatsapp-fill text-lg"></i>
                </a>
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 hover:bg-secondary-200 transition-colors cursor-pointer"
                  aria-label="Instagram"
                >
                  <i className="ri-instagram-fill text-lg"></i>
                </a>
                <a
                  href="https://tiktok.com"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 hover:bg-secondary-200 transition-colors cursor-pointer"
                  aria-label="TikTok"
                >
                  <i className="ri-tiktok-fill text-lg"></i>
                </a>
                <a
                  href="https://youtube.com"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 hover:bg-secondary-200 transition-colors cursor-pointer"
                  aria-label="YouTube"
                >
                  <i className="ri-youtube-fill text-lg"></i>
                </a>
              </div>
            </div>

            <div className="md:col-span-2">
              <h4 className="text-sm font-semibold text-foreground-900 mb-3 font-heading">
                <a href="#categories" className="hover:text-primary-500 transition-colors">İşlemler</a>
              </h4>
              <ul className="flex flex-col gap-2">
                <li><a href="#categories" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors">Saç</a></li>
                <li><a href="#categories" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors">Kalıcı Makyaj</a></li>
                <li><a href="#categories" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors">Lazer Epilasyon</a></li>
                <li><a href="#categories" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors">Cilt Bakımı</a></li>
                <li><a href="#categories" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors">Gençleşme</a></li>
                <li><a href="#categories" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors">Solaryum</a></li>
                <li><a href="#categories" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors">Bölgesel İncelme</a></li>
              </ul>
            </div>

            <div className="md:col-span-3">
              <h4 className="text-sm font-semibold text-foreground-900 mb-3 font-heading">
                <a href="#footer" className="hover:text-primary-500 transition-colors">Popüler</a>
              </h4>
              <ul className="flex flex-col gap-2">
                <li><a href="#categories" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors">Microblading</a></li>
                <li><a href="#categories" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors">Buz Lazer</a></li>
                <li><a href="#categories" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors">Hydrafacial</a></li>
                <li><a href="#categories" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors">Keratin Bakım</a></li>
                <li><a href="#categories" className="text-sm text-foreground-500 hover:text-foreground-800 transition-colors">İpek Kirpik</a></li>
              </ul>
            </div>

            <div className="md:col-span-3">
              <h4 className="text-sm font-semibold text-foreground-900 mb-3 font-heading">
                <a href="#footer" className="hover:text-primary-500 transition-colors">İletişim</a>
              </h4>
              <ul className="flex flex-col gap-2">
                <li className="flex items-center gap-2 text-sm text-foreground-500">
                  <span className="w-4 h-4 flex items-center justify-center shrink-0">
                    <i className="ri-phone-line text-sm text-primary-500"></i>
                  </span>
                  <a href="tel:+905433724578" className="hover:text-foreground-800 transition-colors">+90 543 372 45 78</a>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-500">
                  <span className="w-4 h-4 flex items-center justify-center shrink-0">
                    <i className="ri-mail-line text-sm text-primary-500"></i>
                  </span>
                  <a href="mailto:info@saloonsguzellik.com" className="hover:text-foreground-800 transition-colors">info@saloonsguzellik.com</a>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-500">
                  <span className="w-4 h-4 flex items-center justify-center shrink-0">
                    <i className="ri-map-pin-line text-sm text-primary-500"></i>
                  </span>
                  <span>Değirmen sok. Ata apt. No:8/B<br />İstanbul Kozyatağı<br /><small className="text-foreground-400">Metroya 2 dakika yürüme mesafesi</small></span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-500">
                  <span className="w-4 h-4 flex items-center justify-center shrink-0">
                    <i className="ri-time-line text-sm text-primary-500"></i>
                  </span>
                  <span>Pzt - Cmt: 09:00 - 21:00</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-background-200/70 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} <strong>SaloonS</strong>. Tüm hakları saklıdır.
            </p>
            <div className="flex items-center gap-4">
              <a href="#footer" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors">Gizlilik</a>
              <span className="text-foreground-300">|</span>
              <a href="#footer" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors">KVKK</a>
              <span className="text-foreground-300">|</span>
              <a href="#footer" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors">Çerezler</a>
            </div>
          </div>

          <p className="text-[10px] text-foreground-300 text-center mt-6 leading-relaxed">
            Bu sitede yer alan yorumlar, gerçek müşteri deneyimlerine dayanmaktadır. SaloonS, güzellik ve bakım alanlarında güvenilir hizmet sunmayı taahhüt eder. Tüm işlemler alanında uzman estetisyenler tarafından gerçekleştirilmektedir.
          </p>
        </div>
      </div>
    </footer>
  );
}